module.exports = __webpack_public_path__ + "static/media/regional-icon.31b96787.svg";